
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_1mfbn_rwjs9_103",
  "grid-cell": "awsui_grid-cell_1mfbn_rwjs9_108",
  "day-header": "awsui_day-header_1mfbn_rwjs9_115",
  "week": "awsui_week_1mfbn_rwjs9_125",
  "day": "awsui_day_1mfbn_rwjs9_115",
  "day-inner": "awsui_day-inner_1mfbn_rwjs9_172",
  "in-first-row": "awsui_in-first-row_1mfbn_rwjs9_177",
  "in-previous-month": "awsui_in-previous-month_1mfbn_rwjs9_177",
  "last-day-of-month": "awsui_last-day-of-month_1mfbn_rwjs9_181",
  "in-next-month": "awsui_in-next-month_1mfbn_rwjs9_185",
  "in-first-column": "awsui_in-first-column_1mfbn_rwjs9_189",
  "in-current-month": "awsui_in-current-month_1mfbn_rwjs9_192",
  "enabled": "awsui_enabled_1mfbn_rwjs9_196",
  "in-range": "awsui_in-range_1mfbn_rwjs9_202",
  "end-date": "awsui_end-date_1mfbn_rwjs9_202",
  "start-date": "awsui_start-date_1mfbn_rwjs9_202",
  "no-range": "awsui_no-range_1mfbn_rwjs9_202",
  "selected": "awsui_selected_1mfbn_rwjs9_212",
  "today": "awsui_today_1mfbn_rwjs9_217",
  "range-start-date": "awsui_range-start-date_1mfbn_rwjs9_262",
  "in-range-border-bottom": "awsui_in-range-border-bottom_1mfbn_rwjs9_265",
  "range-end-date": "awsui_range-end-date_1mfbn_rwjs9_268",
  "in-range-border-top": "awsui_in-range-border-top_1mfbn_rwjs9_271",
  "in-range-border-block-start": "awsui_in-range-border-block-start_1mfbn_rwjs9_284",
  "in-range-border-inline-end": "awsui_in-range-border-inline-end_1mfbn_rwjs9_287",
  "in-range-border-block-end": "awsui_in-range-border-block-end_1mfbn_rwjs9_290",
  "in-range-border-inline-start": "awsui_in-range-border-inline-start_1mfbn_rwjs9_293"
};
  